const apiEndpoints = {
  VISA_REQUEST: {
    GET_VISA_REQUEST: "/request",
    CREATE_VISA_REQUEST: "/request",
    SEARCH_VISA_REQUEST: "/request/search",
    CHECK_VISA_REQUEST_STATUS: "/request/check-status",
    UPDATE_VISA_REQUEST: "/request"
  },
  PROFILE: {
    GET_PROFILE_BY_PURPOSE: "/profile/search"
  },
  PAYMENT: {
    PAYPAL: {
      CREATE_ORDER: "/create-order",
      CAPTURE_ORDER: "/capture-order"
    },
    SQUARE: {
      CREATE_PAYMENT: "/create-square-payment"
    }
  },
  NEWS: {
    GET_NEWS: "/post"
  },
  AFFILIATE: {
    GET_AFFILIATE: "/affiliate/user",
    CREATE_SALE_PRODUCT: "/affiliate/product"
  }
};

export default apiEndpoints;
